import { Font } from '@react-pdf/renderer';

export const registerPdfFonts = () => {
    // Register Graphik font only (the one that's already working)
    Font.register({
        family: 'Graphik',
        fonts: [
            {
                fontStyle: 'normal',
                fontWeight: 400,
                format: 'woff',
                src: `../../../../../styles/fonts/Graphik-Regular.woff`
            }
        ]
    });
    Font.register({
        family: 'Verdana',
        fonts: [
            {
                fontStyle: 'normal',
                fontWeight: 400,
                format: 'truetype',
                src: '/fonts/Verdana/Verdana.ttf'
            },
            {
                fontStyle: 'normal',
                fontWeight: 700,
                format: 'truetype',
                src: '/fonts/Verdana/Verdana-Bold.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 400,
                format: 'truetype',
                src: '/fonts/Verdana/Verdana-Italic.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 700,
                format: 'truetype',
                src: '/fonts/Verdana/Verdana-BoldItalic.ttf'
            }
        ]
    });

    // Register EB Garamond font
    Font.register({
        family: 'EBGaramond',
        fonts: [
            {
                fontStyle: 'normal',
                fontWeight: 400,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-Regular.ttf'
            },
            {
                fontStyle: 'normal',
                fontWeight: 500,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-Medium.ttf'
            },
            {
                fontStyle: 'normal',
                fontWeight: 600,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-SemiBold.ttf'
            },
            {
                fontStyle: 'normal',
                fontWeight: 700,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-Bold.ttf'
            },
            {
                fontStyle: 'normal',
                fontWeight: 800,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-ExtraBold.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 400,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-Italic.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 500,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-MediumItalic.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 600,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-SemiBoldItalic.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 700,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-BoldItalic.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 800,
                format: 'truetype',
                src: '/fonts/EB_Garamond/EBGaramond-ExtraBoldItalic.ttf'
            }
        ]
    });

    // Register Georgia font
    Font.register({
        family: 'Georgia',
        fonts: [
            {
                fontStyle: 'normal',
                fontWeight: 400,
                format: 'truetype',
                src: '/fonts/georgia/georgia.ttf'
            },
            {
                fontStyle: 'normal',
                fontWeight: 700,
                format: 'truetype',
                src: '/fonts/georgia/georgiab.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 400,
                format: 'truetype',
                src: '/fonts/georgia/georgiai.ttf'
            },
            {
                fontStyle: 'italic',
                fontWeight: 700,
                format: 'truetype',
                src: '/fonts/georgia/georgiaz.ttf'
            }
        ]
    });
}